import { 
    Box,
    Text
} from '@chakra-ui/react'
import Accordion from './Accordion';

function Order({date, data}: {date: string, data: any}){
    const inputDate = new Date(date);
    const formattedDate = inputDate.toLocaleDateString('ru-RU', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
    });


    //Проверка что date меньше или равна текущей дате
    const currentDate = new Date();


    if (true) {
        if (data.enroll) {
            return(
                <Box>
                    <Text fontSize='2xl' fontWeight='500'>Списки зачисленных от {formattedDate}</Text>
                    {Object.entries(data.enroll).map(([key, value], id) => (
                        <Accordion order={key} data={value} id={id}/>
                    ))}
                </Box>
            )
        } else {
            return(
                <Box>
                    <Text fontSize='2xl' fontWeight='500'>Исключения из приказа от {formattedDate}</Text>
                    {Object.entries(data.cancel).map(([key, value], id) => (
                        <Accordion order={key} data={value} id={id} type={'cancel'}/>
                    ))}
                </Box>
            )
        }
    } else {
        return <></>;
    }
    
}

export default Order;